const tagLabels = {
  宮古島: { EN: "Miyakojima", 中文: "宫古岛", 한국어: "미야코지마" },
  宮古島旅行: {
    EN: "MiyakojimaTrip",
    中文: "宫古岛旅行",
    한국어: "미야코지마여행",
  },
  女子旅: { EN: "GirlsTrip", 中文: "女生旅行", 한국어: "여자여행" },
  宮古島女子旅: {
    EN: "MiyakojimaGirlsTrip",
    中文: "宫古岛女生旅行",
    한국어: "미야코지마여자여행",
  },
  ホテル: { EN: "Hotel", 中文: "酒店", 한국어: "호텔" },
  宮古島ホテル: { EN: "MiyakojimaHotel", 中文: "宫古岛酒店", 한국어: "미야코지마호텔" },
  カフェ巡り: { EN: "CafeHopping", 中文: "咖啡馆巡游", 한국어: "카페투어" },
  グルメ: { EN: "Food", 中文: "美食", 한국어: "맛집" },
  ランチ: { EN: "Lunch", 中文: "午餐", 한국어: "점심" },
  夜ご飯: { EN: "Dinner", 中文: "晚餐", 한국어: "저녁식사" },
  夜遊び: { EN: "Nightlife", 中文: "夜生活", 한국어: "밤여행" },
  フルムーンパーティ: {
    EN: "FullMoonParty",
    中文: "满月派对",
    한국어: "풀문파티",
  },
  焼肉: { EN: "Yakiniku", 中文: "烤肉", 한국어: "야키니쿠" },
  宮古牛: { EN: "MiyakoBeef", 中文: "宫古牛", 한국어: "미야코규" },
  宮古そば: { EN: "MiyakoSoba", 中文: "宫古荞麦面", 한국어: "미야코소바" },
  サーターアンダギー: {
    EN: "SataAndagi",
    中文: "萨塔安达吉",
    한국어: "사타안다기",
  },
  お土産: { EN: "Souvenirs", 中文: "伴手礼", 한국어: "기념품" },
  ドライブ: { EN: "Drive", 中文: "自驾", 한국어: "드라이브" },
  レンタカー: { EN: "RentACar", 中文: "租车", 한국어: "렌터카" },
  格安レンタカー: {
    EN: "CheapRentACar",
    中文: "平价租车",
    한국어: "저렴한렌터카",
  },
  宮古島ドライブ: {
    EN: "MiyakojimaDrive",
    中文: "宫古岛自驾",
    한국어: "미야코지마드라이브",
  },
  サンセット: { EN: "Sunset", 中文: "夕阳", 한국어: "선셋" },
  ビーチ: { EN: "Beach", 中文: "海滩", 한국어: "해변" },
  映えスポット: { EN: "Photogenic", 中文: "拍照打卡", 한국어: "사진스팟" },
  映え: { EN: "Photogenic", 中文: "拍照好看", 한국어: "인생샷" },
  絶景スポット: { EN: "ScenicSpot", 中文: "绝景景点", 한국어: "절경스팟" },
  秘境フォトツアー: { EN: "ScenicTour", 中文: "绝景行程", 한국어: "절경투어" },
  撮影: { EN: "Photography", 中文: "拍摄", 한국어: "촬영" },
  ドローン: { EN: "Drone", 中文: "无人机", 한국어: "드론" },
  ドローン撮影: { EN: "DroneShooting", 中文: "无人机拍摄", 한국어: "드론촬영" },
  SUP: { EN: "SUP", 中文: "SUP", 한국어: "SUP" },
  秘境SUP: { EN: "HiddenSUP", 中文: "秘境SUP", 한국어: "비경SUP" },
  ジェット: { EN: "JetSki", 中文: "摩托艇", 한국어: "제트스키" },
  ジェットツアー: {
    EN: "JetSkiTour",
    中文: "摩托艇行程",
    한국어: "제트스키투어",
  },
  秘境: { EN: "HiddenBeach", 中文: "秘境", 한국어: "비밀스팟" },
  シークレットビーチ: {
    EN: "SecretBeach",
    中文: "秘密海滩",
    한국어: "시크릿비치",
  },
  完全プライベート: {
    EN: "PrivateTour",
    中文: "完全私人行程",
    한국어: "완전프라이빗",
  },
  観光マップに載ってない: {
    EN: "NotOnTouristMaps",
    中文: "旅游地图上没有",
    한국어: "관광지도에없는곳",
  },
  大人の海遊び: {
    EN: "RefinedOceanExperience",
    中文: "成熟海岛体验",
    한국어: "어른의바다체험",
  },
  一番綺麗な海: {
    EN: "ClearestOcean",
    中文: "最美大海",
    한국어: "가장아름다운바다",
  },
  マリンアクティビティ: {
    EN: "MarineActivity",
    中文: "海上活动",
    한국어: "해양액티비티",
  },
  サーフィン: { EN: "Surfing", 中文: "冲浪", 한국어: "서핑" },
  宮古島サーフィン: {
    EN: "MiyakojimaSurfing",
    中文: "宫古岛冲浪",
    한국어: "미야코지마서핑",
  },
  ローカルガイド: {
    EN: "LocalGuide",
    中文: "本地向导",
    한국어: "로컬가이드",
  },
  朝活: { EN: "MorningActivity", 中文: "清晨活动", 한국어: "아침활동" },
  多言語対応: {
    EN: "Multilingual",
    中文: "多语言",
    한국어: "다국어지원",
  },
  海外ゲスト歓迎: {
    EN: "InternationalGuestsWelcome",
    中文: "欢迎海外游客",
    한국어: "해외게스트환영",
  },
  サーフィン体験: {
    EN: "SurfingExperience",
    中文: "冲浪体验",
    한국어: "서핑체험",
  },
  旅動画: { EN: "TravelVideo", 中文: "旅行视频", 한국어: "여행영상" },
  ツアーの様子: {
    EN: "TourExperience",
    中文: "行程体验",
    한국어: "투어후기",
  },
  非日常体験: {
    EN: "ExtraordinaryExperience",
    中文: "非日常体验",
    한국어: "비일상체험",
  },
  モデルコース: { EN: "Itinerary", 中文: "行程", 한국어: "여행코스" },
  八重干瀬: { EN: "Yabiji", 中文: "八重干濑", 한국어: "야비지" },
  星空撮影: { EN: "StarPhotography", 中文: "星空拍摄", 한국어: "별사진촬영" },
  星空: { EN: "Stars", 中文: "星空", 한국어: "별하늘" },
  星空スポット: {
    EN: "StargazingSpot",
    中文: "观星地点",
    한국어: "별보기스팟",
  },
  天の川: { EN: "MilkyWay", 中文: "银河", 한국어: "은하수" },
  新月: { EN: "NewMoon", 中文: "新月", 한국어: "신월" },
  天気: { EN: "Weather", 中文: "天气", 한국어: "날씨" },
  潮位: { EN: "Tide", 中文: "潮位", 한국어: "조위" },
  雨の日: { EN: "RainyDay", 中文: "雨天", 한국어: "비오는날" },
  エニタイムフィットネス: {
    EN: "AnytimeFitness",
    中文: "AnytimeFitness",
    한국어: "애니타임피트니스",
  },
  筋トレ: { EN: "Workout", 中文: "健身", 한국어: "근력운동" },
  レジンアート: { EN: "ResinArt", 中文: "树脂艺术", 한국어: "레진아트" },
  シーサー作り: { EN: "ShisaMaking", 中文: "风狮爷制作", 한국어: "시사만들기" },
  宮古島体験: {
    EN: "MiyakojimaExperience",
    中文: "宫古岛体验",
    한국어: "미야코지마체험",
  },
  パーマネントジュエリー: {
    EN: "PermanentJewelry",
    中文: "永久饰品",
    한국어: "퍼머넌트주얼리",
  },
  カスタムアクセサリー: {
    EN: "CustomAccessory",
    中文: "定制饰品",
    한국어: "커스텀액세서리",
  },
  アクセサリー作り: {
    EN: "AccessoryMaking",
    中文: "饰品制作",
    한국어: "액세서리만들기",
  },
  宮古ブルー: { EN: "MiyakoBlue", 中文: "宫古蓝", 한국어: "미야코블루" },
  伊良部島: { EN: "IrabuIsland", 中文: "伊良部岛", 한국어: "이라부섬" },
  池間島: { EN: "IkemaIsland", 中文: "池间岛", 한국어: "이케마섬" },
  来間島: { EN: "KurimaIsland", 中文: "来间岛", 한국어: "쿠리마섬" },
  下地島: { EN: "ShimojiIsland", 中文: "下地岛", 한국어: "시모지섬" },
  宮古島写真: {
    EN: "MiyakojimaPhoto",
    中文: "宫古岛照片",
    한국어: "미야코지마사진",
  },
  宮古島ランチ: {
    EN: "MiyakojimaLunch",
    中文: "宫古岛午餐",
    한국어: "미야코지마점심",
  },
  宮古島カフェ: {
    EN: "MiyakojimaCafe",
    中文: "宫古岛咖啡馆",
    한국어: "미야코지마카페",
  },
  宮古島グルメ: {
    EN: "MiyakojimaFood",
    中文: "宫古岛美食",
    한국어: "미야코지마맛집",
  },
  宮古島スイーツ: {
    EN: "MiyakojimaSweets",
    中文: "宫古岛甜点",
    한국어: "미야코지마디저트",
  },
  ジェラート: { EN: "Gelato", 中文: "意式冰淇淋", 한국어: "젤라토" },
  スイーツ: { EN: "Sweets", 中文: "甜点", 한국어: "디저트" },
};

export const getLocalizedTag = (tag, lang = "JP") => {
  if (!tag || lang === "JP") {
    return tag;
  }

  const hasHash = String(tag).startsWith("#");
  const key = String(tag).replace(/^#/, "");
  const translated = tagLabels[key]?.[lang];

  return translated ? `${hasHash ? "#" : ""}${translated}` : tag;
};

export const getLocalizedTags = (tags = [], lang = "JP") =>
  Array.isArray(tags) ? tags.map((tag) => getLocalizedTag(tag, lang)) : tags;
